import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import BannerReguests from "services/banner";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid } from "@material-ui/core";

import BannerElement from "./BannerElement";
import { Pagination } from "@material-ui/lab";

import { animateScroll as scroll } from "react-scroll";
import CustomSelect from "./CustomSelect";

const AllBanners = () => {
  const [position, setPosition] = useState("");
  const { allBanners, bannerTotalPages, bannerCurrentPage } = useSelector(
    ({ banner }) => banner
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(BannerReguests.getAllBanners(1, position));
  }, [position]);

  const handleChangePagination = (_, value) => {
    dispatch(BannerReguests.getAllBanners(value, position));
    scroll.scrollToTop();
  };

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          <CustomSelect
            title={"فیلتر بر اساس محل قرارگیری"}
            value={position}
            handleChange={(val) => setPosition(val)}
            options={[
              { value: "Top", text: "بالا" },
              { value: "Bottom", text: "پایین" },
              { value: "Archived", text: "آرشیو شده" },
              { value: "", text: "همه" },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          {allBanners &&
            allBanners.map((banner) => (
              <BannerElement key={banner._id} banner={banner} />
            ))}
        </Grid>
      </GridContainer>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={bannerTotalPages}
          color="primary"
          page={bannerCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default AllBanners;
